import tmhRequest from '@/config/tmhRequest'

export default {

    searchComment: function (data) {
        return tmhRequest({
            url: '/order/tmh/comment/searchcomment',
            method: 'post',
            params: data,
        })
    },

    searchListComment: function (data) {
        return tmhRequest({
            url: '/order/tmh/comment/searchlistcomment',
            method: 'post',
            params: data,
        })
    },
    
    verifyPower: function (data) {
        return tmhRequest({
            url: '/order/tmh/comment/verifypower',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/order/comment.js